import { useParams } from "react-router";
import { VideoCall } from "./VideoCall/VideoCall"
import { Link, VideoCallParams } from "types";
import { useState } from "react";
import VideoCallEnded from "./VideoCallEnded/VideoCallEnded";
import VideoCallLanding from "./VideoCallLanding/VideoCallLanding";
import VideoCallContext from "./VideoCallContext";
import { ardoizLogoV2 } from "assets/images/brand";
import Route from "routes/Routes";
import { navigate, navigateToSelectedChannelRoute } from "utils";
import { useWebUserContext } from "contexts";
import { HIBOU_URL } from "constants/env";

enum VideoCallPageStateEnum {
  SET_USERNAME,
  VIDEO_CALL,
  VIDEO_CALL_ENDED,
}

export type VideoCallPageProps = {
  externalUsername?: string;
  selectedLink?: Link;
}

const VideoCallPage = ({ selectedLink, externalUsername }: VideoCallPageProps): JSX.Element => {
  const { videoCallID, tabletUserFullName, selectedChannel, participantEmail } = useParams<VideoCallParams>();
  const [videoCallPageState, setVideoCallPageState] = useState<VideoCallPageStateEnum>(VideoCallPageStateEnum.SET_USERNAME);
  const [isCameraDisabled, setCameraDisabled] = useState<boolean>(false);
  const [isMicrophoneMuted, setMicrophoneMuted] = useState<boolean>(false);
  const [participantsNumber, setParticipantsNumber] = useState<number>(1);
  const [username, setUsername] = useState<string>(externalUsername);
  let webUserContext = undefined;
  if (!participantEmail) {
    webUserContext = useWebUserContext();
  }

  const hangup = () => {
    if (externalUsername) {
      navigateToSelectedChannelRoute(selectedLink, Route.VIDEO_CALL_LIST);
    } else {
      setVideoCallPageState(VideoCallPageStateEnum.VIDEO_CALL_ENDED);
    }
  }

  const confirmLanding = () => {
    fetch(`${HIBOU_URL}/visio/access/${videoCallID}/${selectedChannel}/${webUserContext?.webUser?.email ?? participantEmail}`)
      .then(response => {
        if (response.status !== 200) navigate(Route.VIDEO_CALL_PAGE_EXPIRED);
        setVideoCallPageState(VideoCallPageStateEnum.VIDEO_CALL);
      })
      .catch(() => navigate(Route.VIDEO_CALL_PAGE_EXPIRED));
    }


  const renderContent = (): JSX.Element => {
    switch(videoCallPageState) {
      case VideoCallPageStateEnum.SET_USERNAME:
        return <VideoCallLanding
          className="self-center m-auto"
          roomName={videoCallID}
          tabletUser={tabletUserFullName ?? `${selectedLink.mainUser.firstName} ${selectedLink.mainUser.lastName}`}
          username={username} 
          setUsername={setUsername}
          editableUsername={!externalUsername}
          onConfirm={confirmLanding} />
      case VideoCallPageStateEnum.VIDEO_CALL:
        return (
          <div className="fixed top-[0] left-[0] z-[1900] w-screen h-screen">
            <VideoCall 
              className="self-center w-full h-full" 
              username={username} 
              onHangup={hangup} 
              roomName={videoCallID} />
          </div>
        );
      case VideoCallPageStateEnum.VIDEO_CALL_ENDED:
        return <VideoCallEnded className="self-center m-auto" />;
      default:
        return;
    }
  }

  return (
    <VideoCallContext.Provider value={{ isCameraDisabled, isMicrophoneMuted, setCameraDisabled, setMicrophoneMuted, participantsNumber, setParticipantsNumber }}>
      <div className="flex flex-col w-full h-full">
        { !externalUsername &&
          <div className="flex justify-center py-2w border-b border-grey-200">
            <img src={ardoizLogoV2} alt="Ardoiz" />
          </div> }
        { renderContent() }
      </div>
    </VideoCallContext.Provider>
  );
}

export default VideoCallPage;